import LifeMapDiagram from '../lifemap/LifeMapDiagram'

/**
 * The life-map graph on every item page (tasks, habits, skills, goals,
 * dreams).
 *
 * Owner, 2026-09-12: the item pages drew a different picture from
 * /life-map — a ReactFlow canvas behind two tabs, "This branch" and "Full
 * life map". Now it is the same renderer the Life Map page uses
 * (`LifeMapDiagram`), focused on this item's branch; the second tab is gone
 * and a link takes you to the Life Map page; every block opens its item,
 * exactly as it does there.
 *
 * The file keeps its historical name so the five mount sites did not have
 * to change while other work was in flight on those pages.
 */
interface DreamGraphTabsProps {
  nodeId: number
  nodeType: string
}

export default function DreamGraphTabs({ nodeId, nodeType }: DreamGraphTabsProps) {
  return (
    <LifeMapDiagram mode="branch" nodeId={nodeId} nodeType={nodeType} compact showFullViewButton />
  )
}
